import { LectureServiceFirestore } from "./LectureServiceFirestore";
import { LectureServiceLocal } from "./LectureServiceLocal";
export class LectureServiceFactory {
    static createLocal() {
        return new LectureServiceLocal();
    }
    static createFirestore(firestore) {
        if (!firestore) {
            throw new Error("Firestore instance is required for Firebase service");
        }
        return new LectureServiceFirestore(firestore);
    }
}
